export default val => {
  if (val < 10000) {
    return val
  } else if (val >= 10000 && val < 1000000) {
    return (val / 10000).toFixed(2) + '万'
  } else if (val >= 1000000 && val < 10000000) {
    return (val / 1000000).toFixed(2) + '百万'
  } else if (val >= 10000 && val < 100000000) {
    return (val / 10000000).toFixed(2) + '千万'
  } else {
    return (val / 100000000).toFixed(2) + '亿'
  }
}
